import GravelRoad from "../../assets/png/Gravel_Road.png";

const GasPowerBennar = ({ title, description, bannerText = "GAS POWERED" }) => {
  return (
    <>
      <div className="relative w-full h-[350px] xs:h-[400px] sm:h-[450px] md:h-[550px] lg:h-[750px] xl:h-[800px] overflow-hidden">
        <img
          src={GravelRoad}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay Container */}
        <div className="absolute inset-0 flex flex-col items-center">
          {/* Top/Middle Section: Centered Content Box */}
          <div className="flex-grow flex items-center justify-center w-full px-4">
            <div className="bg-black/60 px-4 py-3 sm:px-8 sm:py-6 md:px-10 md:py-7 lg:px-14 lg:py-8 rounded-2xl border border-white/10 max-w-[1100px] w-full flex flex-col items-center justify-center backdrop-blur-sm">
              {title && (
                <div className="text-white mb-2 transform scale-[0.8] sm:scale-90 md:scale-100 lg:scale-110">
                  {title}
                </div>
              )}

              {/* Separator Line */}
              <div className="w-1/3 h-[2px]  mb-4"></div>

              {description && (
                <div className="text-center font-[Roboto] text-[#fff] 2xl:text-[24px] xl:text-[22px] lg:text-[19px] md:text-[17px] sm:text-[15px] text-[11px] leading-tight sm:leading-relaxed opacity-95">
                  {description}
                </div>
              )}
            </div>
          </div>

          {/* Bottom Banner Text */}
          <div className="w-full flex justify-center items-end">
            <div
              className="
              text-[#F2F2F2CC] 
              font-extrabold 
              font-[Rockwell]

              2xl:text-[212px]
              lg:text-[104px]
              md:text-[85px] 
              sm:text-[65px] 
              text-[38px] 

              2xl:leading-[152px]
              lg:leading-[74px]
              md:leading-[60px] 
              sm:leading-[47px] 
              leading-[28px]
              "
            >
              {bannerText}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GasPowerBennar;
